import React from "react";
import RegisterCustomerView from "./RegisterCustomerView";
import RegisterInstallerView from "./RegisterInstallerView";

const renderView = (
  type,
  initialValues,
  onRegisterNewInstaller,
  onRegisterNewCustomer,
) => {
  switch (type) {
    case "installer":
      return (
        <RegisterInstallerView
          initialValues={initialValues}
          onSubmit={onRegisterNewInstaller}
        />
      );
    case "customer":
      return (
        <RegisterCustomerView
          initialValues={initialValues}
          onSubmit={onRegisterNewCustomer}
        />
      );
    default:
      return null;
  }
};

const RegisterView = ({
  type,
  initialValues,
  onRegisterNewInstaller = () => {},
  onRegisterNewCustomer = () => {},
}) => {
  return renderView(
    type,
    initialValues,
    onRegisterNewInstaller,
    onRegisterNewCustomer,
  );
};

export default RegisterView;
